import React, { useState } from "react";
import { ScalingContainer } from "../../../AppStyled";

import { HistoryContainer } from "./HistoryStyled";
import { Header, Tr } from "./Header";

// import Chart from "./Chart";
export default function History({
  handleAbove,
  history,
  toFix,
  h,
  userSettings,
  handleVerifyBet,
  user_id,
  handleNotification,
}) {
  const [active, setactive] = useState("my");
  const [currentData, setcurrentData] = useState([]);
  let array = [];
  if (active === "my") array = history.myHistory;
  if (active === "all") array = history.allHistory;
  if (active === "high") array = history.highRoller;
  const current = array.map((h) => h.winAmount - h.betAmount);

  if (JSON.stringify(currentData) !== JSON.stringify(current)) {
    setcurrentData(current);
  }

  return (
    <HistoryContainer className="HistoryContainer">
      <ScalingContainer className="ScalingContainer" h={h}>
        <Header
          handleAbove={handleAbove}
          active={active}
          handleActive={(e) => setactive(e)}
          userSettings={userSettings}
        />
        {/* <Chart currentData={currentData} /> */}
        <table>
          <thead>
            <tr>
              <th className="thUser">USER</th>
              <th className="thPayout"> PAYOUT</th>
              <th className="thProfit">PROFIT</th>
            </tr>
          </thead>
          <tbody>
            {array.map((t, index) => (
              <Tr
                key={index}
                username={t.user_name}
                payout={t.winCoef.toFixed(2)}
                profit={t.winAmount}
                t={t}
                handleVerifyBet={handleVerifyBet}
                handleAbove={handleAbove}
                user_id={user_id}
                userSettings={userSettings}
                handleNotification={handleNotification}
              // currency={t.currency === "USD" ? "S" : undefined}
              />
            ))}
          </tbody>
        </table>
      </ScalingContainer>
    </HistoryContainer>
  );
}
